import { Component, Input } from '@angular/core';

// Native Angular port of the AngularJS `badge` directive.
// Only dependency (svg-icon) is already an Angular component (SvgIconComponent).
@Component({
    selector: 'badge',
    template: `
    <div class="st-badge" [ngClass]="'st-badge--color-' + (color || 'silver')" [class.st-badge--fill]="!!fill">
      <div class="st-badge-content">
        <svg-icon *ngIf="icon" class="sicon sicon--inline sicon--color-current sicon--1em" [name]="icon"></svg-icon>
        <div><ng-content></ng-content></div>
      </div>
    </div>
  `,
})
export class BadgeComponent {
    @Input() icon?: string;
    @Input() label?: string;            // kept for API parity (unused, same as original)
    @Input() color?: string;
    @Input() fill?: boolean | string;   // truthy check covers both string 'fill' and boolean
}